import { useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Card, CardBody } from "@progress/kendo-react-layout";
import { Input } from "@progress/kendo-react-inputs";
import { Loader } from "@progress/kendo-react-indicators";
import { APP_NAME } from "../constants";
import logo from "../assets/ledgerflow-logo-icon.png";

const emptyLogin = { email: "", password: "" };
const emptyRegister = { fullName: "", email: "", password: "", confirmPassword: "" };

export default function AuthPage({ isLoading, onLogin, onRegister, t = {} }) {
  const [isRegistering, setIsRegistering] = useState(false);
  const [loginData, setLoginData] = useState(emptyLogin);
  const [registerData, setRegisterData] = useState(emptyRegister);

  const submitLogin = (event) => {
    event.preventDefault();
    onLogin(loginData);
  };

  const submitRegister = (event) => {
    event.preventDefault();
    onRegister(registerData);
  };

  return (
    <main className="auth-page">
      <Card className="auth-card">
        <CardBody>
          <div className="auth-brand">
            <img className="brand-logo large" src={logo} alt={`${APP_NAME} logo`} />
            <h1>{APP_NAME}</h1>
            <p>{isRegistering ? t.createWorkspace || "Create a secure local workspace" : t.signInSubtitle || "Sign in to your finance workspace"}</p>
          </div>

          {isRegistering ? (
            <form className="form-stack" onSubmit={submitRegister}>
              <Input
                placeholder={t.fullName || "Full name"}
                value={registerData.fullName}
                onChange={(event) => setRegisterData({ ...registerData, fullName: event.value })}
                required
              />
              <Input
                type="email"
                placeholder={t.email || "Email"}
                value={registerData.email}
                onChange={(event) => setRegisterData({ ...registerData, email: event.value })}
                required
              />
              <Input
                type="password"
                placeholder={t.password || "Password"}
                value={registerData.password}
                onChange={(event) => setRegisterData({ ...registerData, password: event.value })}
                required
              />
              <Input
                type="password"
                placeholder={t.confirmPassword || "Confirm password"}
                value={registerData.confirmPassword}
                onChange={(event) => setRegisterData({ ...registerData, confirmPassword: event.value })}
                required
              />
              <Button type="submit" themeColor="primary" icon="lock" disabled={isLoading}>
                {isLoading ? <Loader size="small" /> : t.createAccount || "Create account"}
              </Button>
              <Button type="button" fillMode="flat" onClick={() => setIsRegistering(false)}>
                {t.backToSignIn || "Back to sign in"}
              </Button>
            </form>
          ) : (
            <form className="form-stack" onSubmit={submitLogin}>
              <Input
                type="email"
                placeholder={t.email || "Email"}
                value={loginData.email}
                onChange={(event) => setLoginData({ ...loginData, email: event.value })}
                required
              />
              <Input
                type="password"
                placeholder={t.password || "Password"}
                value={loginData.password}
                onChange={(event) => setLoginData({ ...loginData, password: event.value })}
                required
              />
              <Button type="submit" themeColor="primary" icon="login" disabled={isLoading}>
                {isLoading ? <Loader size="small" /> : t.signIn || "Sign in"}
              </Button>
              <Button type="button" fillMode="flat" onClick={() => setIsRegistering(true)}>
                {t.createAccount || "Create account"}
              </Button>
            </form>
          )}
        </CardBody>
      </Card>
    </main>
  );
}
